export default {
  mode: 'light',
  common: {
    black: '#000',
    white: '#FFF'
  },
  primary: {
    main: '#244295',
    light: '#657ab4',
    dark: '#1c3477',
    contrastText: '#000',
    background: '#fff'
  },
  secondary: {
    main: '#BFBFBF',
    light: '#FAFAFA',
    dark: '#333333',
    contrastText: '#FFFFFF'
  },
  error: {
    main: '#BB0000',
    light: '#FF8888',
    dark: '#880000',
    contrastText: '#880000'
  },
  warning: {
    main: '#E78C07',
    light: '#FABD64',
    dark: '#E78C07',
    contrastText: '#FFF'
  },
  info: {
    main: '#0092D1',
    light: '#91c8f6',
    dark: '#427CAC',
    contrastText: '#666666'
  },
  success: {
    main: '#2B7D2B',
    light: '#ABE2AB',
    dark: '#2B7C2B'
  },
  accent: {
    main: '#E6600D',
    light: '#E09D00',
    dark: '#C14646'
  },
  grey: {
    50: '#333333',
    100: '#666666',
    200: '#9b9191',
    300: '#CCCCCC',
    400: '#E5E5E5',
    500: '#FFFFFF',
    600: '#AEB8C2',
    650: '#262626',
    700: '#434343',
    900: '#595959',
    1000: '#999'
  },
  action: {
    active: '#0099DB',
    hover: 'rgba(0, 0, 0, 0.1)',
    hoverOpacity: '0.4'
  },
  login: {
    background: '#f2f2f2'
  },
  booking: {
    checkBox: '#2E6FEC',
    link: '#4E9BF3',
    button: '#003A7D',
    background: '#F8F8F8',
    dialogFooter: '#FFF',
    info: '#e9e6e4',
    header: '#4F4F4F',
    field: '#B5C5E5',
    backgroundField: '#F8F8FA',
    confirmation: '#EBF4EA',
    confirmationText: '#0C9700',
    borderBox: '#D4D4D5',
    lightSubHeader: '#6D6D6D',
    profileButton: '#4183C4',
    total: '#FAFBEE',
    list: '#FFF'
  },
  profile: {
    buttonGrey: '#ADADAD'
  }
};
